<template style="height: 100%;">
  <div class="Already_test">
    <div class="search_cnt">
      <el-input v-model="content" placeholder="请输入量表名称/发布名称搜索" class="text-search" style="width: 300px !important;"
        maxlength="15" :clearable="true" @clear="removeall"></el-input>
      <el-button @click="loading(1)" type="primary" style="margin-left: 10px;">
        筛选
      </el-button>
    </div>
    <el-table v-loading="loadings" :row-key="(row) => { return row.PaperResultID }" :data="tableData"
      style="width: 100%; margin-top: 10px;" :default-sort="{ prop: 'date', order: 'descending' }">
      <el-table-column label="序号" width="150" align="center">
        <template slot-scope="scope" center>
          {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="测试来源">
        <template slot-scope="scope">
          <span>
            {{ scope.row.PubName ? scope.row.PubName : '全部量表测试' }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column label="量表名称/发布名称">
        <template slot-scope="scope">
          <span>{{ scope.row.PaperName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="发布名称">
        <template slot-scope="scope">
          <span>{{ scope.row.PaperName }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="测试时间" width="300" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.CreatedDate }}</span>
        </template>
      </el-table-column>
      <!-- 
      <el-table-column label="测试用时">
        <template slot-scope="scope">
          <span v-if="scope.row.IsSubmit == '已生成报告'">{{ scope.row.SETime }}</span>
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">
            查看报告
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" v-if="tableData.length > 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next"
        :total="Counts"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageIndex: 1,
      loadings: false,
      content: '',
      tableData: [],
      Counts: 1,
      currentPage1: 1,
      formInline: {
        Name: '',
        Student: '',
        ScaleName: '',
        TestTime: '',
        PublishID: '',
        ObjectS: '',
        StudyTime: '',
        Warning: '',
      },
    }
  },
  methods: {
    handleEdit(index, row) {
      this.$router.push({
        path: '/measurement/PaperTest',
        query: { PaperID: row.PaperID },
      })
    },
    handleDelete(index, row) { },
    handleClick(a, b) {
      window.open(a.PCReportURL, '_blank')
    },
    handleSizeChange(val) { },
    handleCurrentChange(val) {
      this.loading(val)
    },
    loading(num) {
      this.pageIndex = num;
      this.loadings = true;
      this.$Http_Post('Paper/GetPaperReport', { UserID: this.Global.userID, PageCount: '10', PageIndex: num - 1, paperName: this.content })
        .then((res) => {
          if (res.Code == 0) {
            this.loadings = false;
            this.tableData = res.Data;
            this.Counts = Number(res.Counts);
          } else {
            this.loadings = false;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          })
        })
    },
    resetForm() {
      this.content = ''
      this.loading(1)
    },
    removeall() {
      this.loading(1)
    },
  },
  mounted() {
    this.loading(1)
  },
}
</script>
<style>
.Already_test {border: 1px solid #e7e7e7;padding: 16px;position: relative;background-color: #fff;min-height: 750px;}
.Already_test h2 {font-size: 20px;padding-bottom: 20px;}
.Already_test .block {float: right;margin-top: 0px;}
.Already_test .search_cnt {text-align: center;}
.search_cnt .s-cnt {width: 460px;}
/* .sssvd {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: rgba(21, 191, 109, 1);
  border-radius: 50%;
  margin-right: 10px;
}
.sssvd2 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: rgb(72, 33, 248);
  border-radius: 50%;
  margin-right: 10px;
}
.sssvd3 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: rgba(255, 193, 23, 1);
  border-radius: 50%;
  margin-right: 10px;
}
.sssvd4 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: rgba(240, 43, 46, 1);
  border-radius: 50%;
  margin-right: 10px;
}
.sssvd5 {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: rgba(173, 0, 3, 1);
  border-radius: 50%;
  margin-right: 10px;
} */
.Already_test .el-input {width: 260px !important;}
/* .Already_test .el-table .cell {
  text-align: center;
} */
</style>
